<div mat-dialog-title class="animate__animated animate__fadeIn">
  <h1 class="titulo-simpli">Observaciones folio {{data.folio}}</h1>
  <small class="subtitulo-simpli">Crea y deja tu observación</small>
</div>

<div mat-dialog-content class="animate__animated animate__fadeIn">
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">

    <!-- HAY OBSERVACIONES -->
    <div *ngIf="hasObs" class="row observations-container" #obsContainer>
      <div *ngFor="let obs of observaciones" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
        <div class="observation" [ngClass]="{'der': obs.tipo === 'der'}">

          <div class="avatar">
            <span *ngIf="!obs.hasAvatar">{{ obs.initials }}</span>
            <img *ngIf="obs.hasAvatar" [src]="obs.avatar" (error)="handleError()" alt="avatar"
              style="width: 50px; height: 50px; border-radius: 50%;">
          </div>

          <div class="content-container">

            <div class="author">
              <span>{{ obs.fullname }}</span>
            </div>

            <div class="message-container">
              <div class="message">
                {{ obs.contenido }}
              </div>
              <div class="date">
                {{ obs.fechaHora }}
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>

    <!-- SIN OBSERVACIONES -->
    <div *ngIf="!hasObs" class="row observations-container">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">

        <div class="sinRegistros" style="text-align: center;background: none;">
          <small class="small-sinregistros" style="font-size: 15px;">
            <div style="text-align: center;"><i style="font-size: 30px;color:gray;margin-bottom: 20px;"
                class="fa-light fa-empty-set"></i></div>
            No hay información.
          </small>
        </div>

      </div>
    </div>

    <!-- INPUT OBSERVACIONES -->
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 inputObs">

        <form (submit)="sendForm($event)">
          <mat-form-field color="primary">
            <mat-label>Escribe una observación</mat-label>
            <textarea matInput name="observacion" required #mensajeInput></textarea>
            <button mat-icon-button matSuffix style=" color: #924eff;" type="submit">
              <span *ngIf="spinner"><i class="fa-solid fa-spinner fa-spin-pulse"></i></span>
              <span *ngIf="!spinner"><i class="fa-sharp fa-solid fa-paper-plane-top"></i></span>
            </button>
            <mat-hint>La observación es requerida</mat-hint>
          </mat-form-field>
        </form>

      </div>
    </div>
  </div>
</div>

<div mat-dialog-actions>
  <button mat-flat-button color="primary" class="secondary-button" mat-dialog-close>Cerrar</button>
</div>